import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationsRoute: InvariantJiraRoute = {
	name: 'eoc-team-integrations',
	path: '/jira/ops/teams/:teamId/integrations',
	exact: true,
};
